import React from "react"
import MapListingContent from "./mapListingContent.js"
import NumberFormat from "react-number-format"
import getSymbolFromCurrency from "currency-symbol-map"
import { convertCents } from "../../../utils"
import { trackMapMarkerOpen } from "components/elements/tracking/searchTracking.js"
import Skeleton from 'react-loading-skeleton'
import Tippy from "@tippyjs/react"
import { filter } from 'lodash'
import { apiProcess } from 'components/api/api'
import { CLOUDINARY_NAME, CLOUDINARY_API_KEY } from "../../../../constants/images/cloudinary"
import { USER_MEDIUM_PARAMS } from "../../../../constants/images/sizesAndQuality"
import cloudinary from "cloudinary-core"
import PartnerPopUp from "../../../partners/searchMapPopUp/partnerPopUp.js"
import { findMultidayPrice } from "../searchUtil.js"
const cl = new cloudinary.Cloudinary({
  cloud_name: CLOUDINARY_NAME,
  api_key: CLOUDINARY_API_KEY,
})

const BuildTriggerLabel = ({ info, startDate, endDate }) => {
  if (info.length === 1) {
    return (
      <div
        className="tag map-single-label has-box-shadow"
      //onMouseOver={() => alert()}
      >
        <NumberFormat
          defaultValue={convertCents(findMultidayPrice(info[0], startDate, endDate))}
          displayType={"text"}
          thousandSeparator={true}
          decimalScale={0}
          prefix={getSymbolFromCurrency(info[0].day_price_currency)}
        />
      </div>
    )
  } else {
    return (
      <div
        className="map-multi-label"
        style={{
          backgroundImage:
            "url(" + cl.url(info[0].bike_owner_avatar_id, USER_MEDIUM_PARAMS) + ")"
        }}
      >
        <div className="map-multi-inner">
          <div className="tag is-floating is-secondary">{info.length}</div>
        </div>
      </div>
    )
  }
}

const FakeCard = ({ searchCardClass }) => {
  return (
    <div style={{ width: 280 }}>
      <Skeleton height={200}/>
      <div className="mt-2">
        <Skeleton width={200} height={10} />
        <Skeleton width={250} height={15} />
        <Skeleton width={200} height={10} />
      </div>
    </div>
  )
}

class MapMarker extends React.Component {
  constructor() {
    super()
    this.state = {
      hasBikeData: false,
      bikeData: []
    }
  }

  getMotoIDs = info => {
    let motoIDs = []

    for (let i = 0; i < info.length; i++) {
      motoIDs.push(info[i].bike_id)
    }

    return motoIDs
  }

  fetchBikeFullInfo = (bikeInfo) => {
    let apiUrl = `motorcycles/mapbox/${bikeInfo.bike_owner_id}`
    apiProcess(apiUrl, false, 'mapbox-bike-search','get bike info for mapbox pop-up modal')
    .then((res) => {
      this.setState({
        bikeData: res.results,
        hasBikeData: true
      })
      let motoInfo = res.results[0]
      motoInfo.bike_distance = bikeInfo['bike_distance']
      trackMapMarkerOpen(motoInfo)
    })
    .catch((error) => {
      console.log('failed to fetch bike info on mapbox');
    })
  }

  render() {
    const { info, index, startDate, endDate, searchResults } = this.props
    const { hasBikeData, bikeData } = this.state

    let focusClass = ""
    if (this.props.focused) {
      // focusClass = " result-hover-active-map"
      //console.log('hovering now', info[0].bike_id)
    }

    return (
      <div
        key={index}
        lat={info[0].bike_location.latitude}
        lng={info[0].bike_location.longitude}
        className={"map-popup-search"}
      >
        {!info[0].is_partner && (
          <Tippy
            trigger="click"
            sticky={true}
            arrow={true}
            arrowType={"sharp"}
            hideOnClick={true}
            className="map-pop-over-content"
            theme="light-border"
            interactive={true}
            boundary={() => document.getElementById("search-right-map")}
            content={ hasBikeData ? 
              <MapListingContent
                info={bikeData}
                startDate={startDate}
                endDate={endDate}
              /> : <div className="p-2"><FakeCard /></div>
            }
            onShow={() =>{
              this.props.onOpen()
              let tempBikeInfo = filter(searchResults, { 'bike_owner_id': info[0].bike_owner_id })
              if (tempBikeInfo.length > 0) {
                this.setState({
                  hasBikeData: true,
                  bikeData: [...tempBikeInfo]
                })
              } else {
                // fetch bike info only if it's not exist
                this.fetchBikeFullInfo(info[0])
              }
            }}
            onClickOutside={() => {
              this.setState({
                hasBikeData: false,
                bikeData: []
              })
            }}
            appendTo={() => document.getElementById("search-right-map")}
          >
            <button
              className={"map-trigger-button" + focusClass}
              // onMouseEnter={() => this.props.onHover(info[0].bike_id)}
              // onMouseLeave={() => this.props.onHover(null)}
            >
              <BuildTriggerLabel
                info={info}
                startDate={startDate}
                endDate={endDate}
              />
            </button>
          </Tippy>
        )}
        {info[0].is_partner && (
          <PartnerPopUp
            startDate={startDate}
            endDate={endDate}
            focused={this.props.focused}
            info={hasBikeData ? bikeData : info}
          />
        )}
      </div>
    )
  }
}

export default MapMarker

MapMarker.defaultProps = {
  info: [],
  index: null,
  onOpen: function () { },
  onHover: function () { },
  focused: false,
  startDate: null,
  endDate: null
}